import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ConfigurationService } from '../services/configuration.service';


@Injectable()
export class NlogService {
    private readonly _nLogUrl: string = "/api/nlog";
    private _authService: AuthService;

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }
    constructor(private http: HttpClient, private injector: Injector) { }

    getAllNlogs() {
        return this.http.get('/api/nlog', this.getAuthHeader(true));
    }

    deleteNlogById(ids: string) {
        return this.http.get(`${this._nLogUrl}/DeleteNlogById/${ids}`, this.getAuthHeader(true));
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        const options = {
            headers: headers
        };

        return options;
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/nlog.service.ts